
	import { defineComponent, ref } from 'vue'
	import AppList from './AppList.vue'
	import ReviewList from './ReviewList.vue'
	export default defineComponent({
		components: {
			AppList,
			ReviewList
		},
		setup() {
			const activeKey = ref('review')
			return {
				activeKey
			}
		}
	})
